/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
import "./Home.css";
import "bootstrap/dist/css/bootstrap.min.css";
import NavBar from "../NavBar";
import Banner from "../Banner";
import Projects from "../Projects/Projects";
import Contact from "../Contact";
import Footer from "../Footer";

export default function Home(): JSX.Element {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}
